export default "__VITE_ASSET__f3UUxE0y__"